module.exports = "pegasus/assets/three-column-text-preview.png";